import { createFeatureSelector, createSelector, State } from '@ngrx/store';

import { USER_DATA, UserDataState } from './user-data.reducer';

export const selectUserDataState = createFeatureSelector<UserDataState>(USER_DATA);

export const userDataState = createSelector(selectUserDataState, state => state);
